// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { OperatorType, RoleType } from 'util/Enums';
import { AdminPool } from './AdminPool';
import { EmissionAdminOperator } from './EmissionAdminOperator';
import { EmissionAdminSite } from './EmissionAdminSite';
import { CollectionAdminOperator } from './CollectionAdminOperator';
import { CollectionUserNormal } from './CollectionUserNormal';
import { CompressionRecycleAdminOperator } from './CompressionRecycleAdminOperator';

export const Mypage = () => {
  const user = useSelector(selectUser);

  if (user.operatorType === OperatorType.Emissions) {
    if (user.role === RoleType.AdminOperator) {
      return <EmissionAdminOperator />;
    }

    if (user.role === RoleType.AdminSite) {
      return <EmissionAdminSite />;
    }
  }

  if (user.operatorType === OperatorType.Collects) {
    if (user.role === RoleType.AdminOperator) {
      return <CollectionAdminOperator />;
    }

    if (user.role === RoleType.UserNormal) {
      return <CollectionUserNormal />;
    }
  }

  if (
    (user.operatorType === OperatorType.Compressions ||
      user.operatorType === OperatorType.Recycle) &&
    user.role === RoleType.AdminOperator
  ) {
    return <CompressionRecycleAdminOperator />;
  }

  if (user.role === RoleType.AdminPool) {
    return <AdminPool />;
  }

  return null;
};
